import { withIcon } from '../Icon/Icon.hoc';
import { accountBalance, add, addCircle, alarm, arrowDown, block, bpay, calendar, cancel, check, checkCircle, chevronLeft, chevronPipeLeft, chevronPipeRight, chevronRight, clear, cloudUpload, creditCard, description, cvv, done, email, error, event, expandLess, expandMore, florist, gas, heart, heartOutline, highlightOff, home, hotwater, info, launch, laundry, present, lightbulbOutline, localPrintShop, lock, lockOpen, lockOpenFat, lpg, mastercardBlack, mastercardColor, menu, notificationNone, pdf, person, personOutline, phone, phonelink, place, promoTag, questionAnswer, questionMark, questionMarkOutline, receipt, remove, rewardsMedal, saveAlt, search, sunny, trade, usage, visaBlack, visaColor, warning, watchLater } from './skins';
export var AccountBalanceIcon =
/*#__PURE__*/
withIcon(accountBalance, 'AccountBalance');
export var AddCircleIcon =
/*#__PURE__*/
withIcon(addCircle, 'AddCircle');
export var AddIcon =
/*#__PURE__*/
withIcon(add, 'Add');
export var AlarmIcon =
/*#__PURE__*/
withIcon(alarm, 'AlarmIcon');
export var ArrowDownIcon =
/*#__PURE__*/
withIcon(arrowDown, 'ArrowDown');
export var BlockIcon =
/*#__PURE__*/
withIcon(block, 'BlockIcon');
export var BpayIcon =
/*#__PURE__*/
withIcon(bpay, 'Bpay');
export var CalendarIcon =
/*#__PURE__*/
withIcon(calendar, 'Calendar');
export var CancelIcon =
/*#__PURE__*/
withIcon(cancel, 'CancelIcon');
export var CheckCircleIcon =
/*#__PURE__*/
withIcon(checkCircle, 'CheckCircle');
export var CheckIcon =
/*#__PURE__*/
withIcon(check, 'Check');
export var ChevronLeftIcon =
/*#__PURE__*/
withIcon(chevronLeft, 'ChevronLeft');
export var ChevronPipeLeftIcon =
/*#__PURE__*/
withIcon(chevronPipeLeft, 'ChevronPipeLeft');
export var ChevronPipeRightIcon =
/*#__PURE__*/
withIcon(chevronPipeRight, 'ChevronPipeRight');
export var ChevronRightIcon =
/*#__PURE__*/
withIcon(chevronRight, 'ChevronRight');
export var ClearIcon =
/*#__PURE__*/
withIcon(clear, 'Clear');
export var CloudUploadIcon =
/*#__PURE__*/
withIcon(cloudUpload, 'CloudUpload');
export var CreditCardIcon =
/*#__PURE__*/
withIcon(creditCard, 'CreditCard');
export var CvvIcon =
/*#__PURE__*/
withIcon(cvv, 'Cvv');
export var DescriptionIcon =
/*#__PURE__*/
withIcon(description, 'Description');
export var DoneIcon =
/*#__PURE__*/
withIcon(done, 'Done');
export var EmailIcon =
/*#__PURE__*/
withIcon(email, 'Email');
export var ErrorIcon =
/*#__PURE__*/
withIcon(error, 'Error');
export var EventIcon =
/*#__PURE__*/
withIcon(event, 'Event');
export var ExpandLessIcon =
/*#__PURE__*/
withIcon(expandLess, 'ExpandLess');
export var ExpandMoreIcon =
/*#__PURE__*/
withIcon(expandMore, 'ExpandMore');
export var FloristIcon =
/*#__PURE__*/
withIcon(florist, 'Florist');
export var GasIcon =
/*#__PURE__*/
withIcon(gas, 'Gas');
export var HeartIcon =
/*#__PURE__*/
withIcon(heart, 'heart');
export var HeartOutlineIcon =
/*#__PURE__*/
withIcon(heartOutline, 'HeartOutline');
export var HighlightOffIcon =
/*#__PURE__*/
withIcon(highlightOff, 'HighlightOff');
export var HomeIcon =
/*#__PURE__*/
withIcon(home, 'Home');
export var HotwaterIcon =
/*#__PURE__*/
withIcon(hotwater, 'Hotwater');
export var InfoIcon =
/*#__PURE__*/
withIcon(info, 'Info');
export var LaunchIcon =
/*#__PURE__*/
withIcon(launch, 'Launch');
export var LaundryIcon =
/*#__PURE__*/
withIcon(laundry, 'Laundry');
export var LightbulbOutlineIcon =
/*#__PURE__*/
withIcon(lightbulbOutline, 'LightbulbOutline');
export var LocalPrintShopIcon =
/*#__PURE__*/
withIcon(localPrintShop, 'LocalPrintShop');
export var LockIcon =
/*#__PURE__*/
withIcon(lock, 'Lock');
export var LockOpenIcon =
/*#__PURE__*/
withIcon(lockOpen, 'LockOpen');
export var LockOpenFatIcon =
/*#__PURE__*/
withIcon(lockOpenFat, 'LockOpenFat');
export var LpgIcon =
/*#__PURE__*/
withIcon(lpg, 'Lpg');
export var MastercardBlackIcon =
/*#__PURE__*/
withIcon(mastercardBlack, 'MastercardBlack');
export var MastercardColorIcon =
/*#__PURE__*/
withIcon(mastercardColor, 'MastercardColor');
export var MenuIcon =
/*#__PURE__*/
withIcon(menu, 'Menu');
export var NotificationNoneIcon =
/*#__PURE__*/
withIcon(notificationNone, 'NotificationNone');
export var PDFIcon =
/*#__PURE__*/
withIcon(pdf, 'PDF');
export var PersonIcon =
/*#__PURE__*/
withIcon(person, 'Person');
export var PersonOutlineIcon =
/*#__PURE__*/
withIcon(personOutline, 'PersonOutline');
export var PhoneIcon =
/*#__PURE__*/
withIcon(phone, 'Phone');
export var PhonelinkIcon =
/*#__PURE__*/
withIcon(phonelink, 'Phonelink');
export var PlaceIcon =
/*#__PURE__*/
withIcon(place, 'Place');
export var PresentIcon =
/*#__PURE__*/
withIcon(present, 'Present');
export var PromoTagIcon =
/*#__PURE__*/
withIcon(promoTag, 'PromoTag');
export var QuestionAnswerIcon =
/*#__PURE__*/
withIcon(questionAnswer, 'QuestionAnswer');
export var QuestionMarkIcon =
/*#__PURE__*/
withIcon(questionMark, 'QuestionMark');
export var QuestionMarkOutlineIcon =
/*#__PURE__*/
withIcon(questionMarkOutline, 'QuestionMarkOutline');
export var ReceiptIcon =
/*#__PURE__*/
withIcon(receipt, 'Receipt');
export var RemoveIcon =
/*#__PURE__*/
withIcon(remove, 'Remove');
export var RewardsMedalIcon =
/*#__PURE__*/
withIcon(rewardsMedal, 'RewardsMedal');
export var SaveAltIcon =
/*#__PURE__*/
withIcon(saveAlt, 'SaveAlt');
export var SearchIcon =
/*#__PURE__*/
withIcon(search, 'Search');
export var SunnyIcon =
/*#__PURE__*/
withIcon(sunny, 'Sunny');
export var TradeIcon =
/*#__PURE__*/
withIcon(trade, 'Trade');
export var UsageIcon =
/*#__PURE__*/
withIcon(usage, 'UsageIcon');
export var VisaBlackIcon =
/*#__PURE__*/
withIcon(visaBlack, 'VisaBlack');
export var VisaColorIcon =
/*#__PURE__*/
withIcon(visaColor, 'VisaColor');
export var WarningIcon =
/*#__PURE__*/
withIcon(warning, 'Warning');
export var WatchLaterIcon =
/*#__PURE__*/
withIcon(watchLater, 'WatchLater');